import { getAuthCode } from "./getAuthCode";
export const fetchInsights = async (setInsights) => {
    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/retrieveinsights", {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode()})
      });
      const result = await response.json();
      console.log(result);
      result.sort((a, b) => new Date(b.dateDetected) - new Date(a.dateDetected));
      setInsights(result);
    } catch (error) {
      console.log(error);
    }
  };